export default __webpack_public_path__ + "static/it_hero@2x-ffafcc64e83ed4fede8b80b5dd95915c.jpg";